import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { marked } from 'marked';
// Strip raw HTML blocks — matches previous disableParsingRawHTML behaviour
marked.use({ renderer: { html: () => '' } });
/**
 * @export
 * Renders markdown as styled HTML using UXP typography styles.
 * Supports headings, paragraphs, lists, code blocks, blockquotes, links, and horizontal rules.
 *
 * @example
 * ```tsx
 * <MarkdownPreview value={markdownString} />
 * ```
 */
const MarkdownPreview = ({ value, className, emptyText, compact, maxLines, }) => {
    if (!(value === null || value === void 0 ? void 0 : value.trim())) {
        return emptyText ? (_jsx("p", { className: "uxpcore_markdown_preview__empty", children: emptyText })) : null;
    }
    const html = marked.parse(value);
    /* Compact mode is pure CSS — `--line-clamp` drives the clamp count.
     * Setting an inline custom property is safe; it doesn't bleed into
     * regular CSS rules. */
    const style = compact
        ? { ['--line-clamp']: String(maxLines !== null && maxLines !== void 0 ? maxLines : 5) }
        : undefined;
    return (_jsx("div", { className: classNames('uxpcore_markdown_preview', compact && 'uxpcore_markdown_preview--compact', className), style: style, dangerouslySetInnerHTML: { __html: html } }));
};
export default MarkdownPreview;
